import { Box, Button, Icon } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCandidateHistoriesDownloadTemplate } from '../../../../../api-refactored/exam-configuration/useGetCandidateHistoriesDownloadTemplate';

const DownloadTemplate = ({ classes }: { classes: any }) => {
  const { t } = useTranslation();

  const { refetch: onDownloadTemplate } = useGetCandidateHistoriesDownloadTemplate({
    onSuccess: (res) => {
      const newWindow = window.open(res.url, '_blank', 'noopener,noreferrer');
      if (newWindow) {
        newWindow.opener = null;
      }
    },
  });

  return (
    <Box className={classes.downloadButton}>
      <Button
        id="button-bulkUpload-downloadTemplate"
        size="medium"
        className={classes.downloadTemplateButton}
        variant="outlined"
        onClick={() => onDownloadTemplate()}
        startIcon={<Icon name={IconName.download} size="S" color="primary" />}
      >
        {t('exam->>ExamConfiguration.DownloadTemplate')}
      </Button>
    </Box>
  );
};

export default DownloadTemplate;
